import React from 'react';
import PropTypes from 'prop-types';

/**
 * Abstraction over text input to enforce consistency in validation and labels
 */
const PasswordInput = ({name, label, isRequired, onChange, placeholder, value, error, ...props}) => {
  let inputStyle = {};
  if (error && error.length > 0) {
    inputStyle = {
      borderColor: '#d10f0f'
    }
  }
  return (
    <div className="field af-textinp-container">
      <label className="af-label" htmlFor={name}>{label}</label>{ isRequired && "*" }
      <input
        type='password'
        name={name}
        className="form-control gsp-textinp af-textinp"
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        style={inputStyle}
        {...props}/>
      {error && <div className="af-errormsg">{error}</div>}
    </div>
  );
};


PasswordInput.propTypes = {
  /**
   * Input name
   */
  name: PropTypes.string.isRequired,
  /**
   * Input label
   */
  label: PropTypes.string.isRequired,
  /**
   * Mark label with asterisk if set to true
   */
  isRequired: PropTypes.bool,
  /**
   * Function to call onChange
   */
  onChange: PropTypes.func.isRequired,
  /**
   * Placeholder to display when empty
   */
  placeholder: PropTypes.string,
  /**
   * Value
   */
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number
  ]),
  /**
   * String to display when error occurs
   */
  error: PropTypes.string,
};

export default PasswordInput;



// WEBPACK FOOTER //
// ./src/components/common/PasswordInput.js